import mixpanel from 'mixpanel-browser';
import TagManager from 'react-gtm-module';
import { MIXPANEL_TOKEN } from 'constants/urls';

if (CONFIG.GTM1) {
  TagManager.initialize({
    gtmId: CONFIG.GTM1
  });
}

if (CONFIG.GTM2) {
  TagManager.initialize({
    gtmId: CONFIG.GTM2
  });
}

mixpanel.init(MIXPANEL_TOKEN);

const envcheck = NODE_ENV === 'production';
const actions = {
  identify: id => {
    if (envcheck) mixpanel.identify(id);
  },
  alias: id => {
    if (envcheck) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (envcheck) {
      mixpanel.track(name, props);
      dataLayer.push({
        event: name,
        props
      });
    }
  },
  trackGoogle: (category, action, label) => {
    if (envcheck) {
      dataLayer.push({
        event: category,
        eventProps: {
          action,
          label
        }
      });
    }
  },
  people: {
    set: props => {
      if (envcheck) mixpanel.people.set(props);
    }
  }
};

export const Analytics = actions;
